import React from 'react';
import { returnCurrencyCharFromCode } from '../../../utils/globals';

export const PromoThreshold1 = () => (
  <b>{`${process.env.GATSBY_CURRENCY_THRESHOLD_ONE}${returnCurrencyCharFromCode(
    process.env.GATSBY_CURRENCY
  )}`}</b>
);

export const PromoThreshold2 = () => (
  <b>{`${process.env.GATSBY_CURRENCY_THRESHOLD_TWO}${returnCurrencyCharFromCode(
    process.env.GATSBY_CURRENCY
  )}`}</b>
);
